import React from 'react'

import { datadogRum } from '@datadog/browser-rum'
import {
  getAffiliate,
  setQRRedirect,
  createCookie,
} from '@smarty-nx/code-utils'
import { initDatadogRum } from '@smarty-nx/debug-utils'
import { attach, setDmpgObject } from '@smarty-nx/tracking'
import ReactModal from 'react-modal'
import { Provider } from 'react-redux'
import { ParallaxProvider } from 'react-scroll-parallax'
import { ThemeProvider } from 'styled-components'

import 'url-search-params-polyfill'
import CustomLayout from './gatsby-shared'
import { theme } from './src/constants/theme'
import { store } from './src/state/createStore'
import { saveState } from './src/state/localStorage'
import './src/static/scripts/genesys'
import { pathMap, regexPathMap } from './src/static/scripts/pageViews'

// Save auth info to localeStorage on each change
store.subscribe(() => saveState(store.getState()))

const scrollTo = (id) => () => {
  const el = document.querySelector(id)
  if (el) return window.scrollTo(0, el.offsetTop - 20)
  return false
}

const activate = () => {
  if (window.dataLayer) {
    window.dataLayer.push({ event: 'optimize.activate' })
  }
}

export const onRouteUpdate = ({ location }) => {
  activate()

  datadogRum.startView(location.href)

  const { hash } = location
  if (hash) {
    window.setTimeout(scrollTo(hash), 10)
  }
}

export const onClientEntry = async () => {
  const urlSearch = window.location.search
  const urlPath = window.location.pathname
  const url = window.location.href
  const { referrer } = document
  const affiliate = urlSearch ? getAffiliate({ url, referrer }) : null

  if (affiliate) {
    createCookie({ name: 'affiliate', value: affiliate, days: 30 })
  }

  if (urlPath === '/data-sim' || urlPath === '/data-sim/') {
    setQRRedirect(urlSearch)
  }

  const platform = {
    version: process.env.GATSBY_VERSION,
    commit: process.env.GATSBY_COMMIT,
  }
  setDmpgObject({ pathMap, regexPathMap, platform })
  attach(document, window.smDl)

  initDatadogRum({
    applicationId: process.env.GATSBY_DATADOG_APP_ID,
    clientToken: process.env.GATSBY_DATADOG_TOKEN,
    site: process.env.GATSBY_DATADOG_HOST,
    service: process.env.GATSBY_DATADOG_SERVICE_NAME,
    env: process.env.GATSBY_SMARTY_ENV,
    commit: process.env.GATSBY_COMMIT,
    sessionReplay: process.env.GATSBY_SMARTY_ENV !== 'localhost',
    sessionReplaySampleRate: Number(
      process.env.GATSBY_DATADOG_SESSION_REPLAY_SAMPLE_RATE
    ),
    defaultPrivacyLevel: process.env.GATSBY_DATADOG_DEFAULT_PRIVACY_LEVEL,
  })
}

export const onInitialClientRender = () => {
  ReactModal.setAppElement('#___gatsby')
}

export const wrapRootElement = ({ element }) => (
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <ParallaxProvider>{element}</ParallaxProvider>
    </ThemeProvider>
  </Provider>
)

export const wrapPageElement = CustomLayout
